import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { InfoTypeEnum } from './info.interface';

@Component({
  selector: 'shared-ui-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css'],
  imports: [NgClass],
})
export class InfoComponent {
  type = input<InfoTypeEnum>(InfoTypeEnum.INFO);

  text = input<string>();
  protected readonly InfoTypeEnum = InfoTypeEnum;
}
